jQuery(document).ready(function ($) {
    const gallery = new Swiper('.recent-projects__carousel', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 24,

        pagination: {
            el: '.recent-projects__carousel--pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: false,
        //delay: 8000,
        speed: 500,

        breakpoints: {
            768: {
                slidesPerView: 2
            }
        }
    });
});